import { GlobalAxios } from "../axios/axios-config";
import {
  IListImportAutomation,
  INewListImportAutomation,
} from "../models/list-import-automation";

const LIST_IMPORT_AUTOMATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportAutomation";

export const createListImportAutomation = (item: INewListImportAutomation) => {
  return GlobalAxios.post(LIST_IMPORT_AUTOMATION_ROUTE, item);
};

export const getListImportAutomation = (id: string) => {
  return GlobalAxios.get<IListImportAutomation>(
    LIST_IMPORT_AUTOMATION_ROUTE + "/" + id
  );
};

export const updateListImportAutomation = ({
  item,
  id,
}: {
  item: INewListImportAutomation;
  id: string;
}) => {
  return GlobalAxios.put(LIST_IMPORT_AUTOMATION_ROUTE + "/" + id, item);
};
